import { useCallback } from 'react';
export const useSetInputRef = ({
  focusInputRef,
  blurInputRef
}) => {
  return useCallback(el => {
    if (el) {
      if (focusInputRef) {
        focusInputRef.current = () => el.focus();
      }
      if (blurInputRef) {
        blurInputRef.current = () => el.blur();
      }
      // Set selection to end of the input
      el.selectionStart = el.selectionEnd = el.value.length;
    }
  }, [focusInputRef, blurInputRef]);
};